var $21ed339991267e1d$exports = {};
$21ed339991267e1d$exports = {
    "actions": `Akce`,
    "hideButtonLabel": `Zobrazit m\xe9n\u{11B}`,
    "noTags": `\u{17D}\xe1dn\xfd`,
    "showAllButtonLabel": (args, formatter)=>`Zobrazit v\u{161}e (${formatter.number(args.tagCount)})`
};


export {$21ed339991267e1d$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
